/*jshint globalstrict: false*/
import CommonMixin from './common-mixin';

const BG_COLORS = ['#E1E5EC', '#E7E3ED', '#DDEAE1', '#F2E5E9', '#F8F2E7', '#F1F7F6', '#E5DDE8'];
const FONT_COLORS = ['#B9BDC4', '#B5B1BB', '#ABB8AF', '#C0B3B7', '#C6C0B5', '#BFC5C4', '#B3ABB6'];

export default {
  mixins: [CommonMixin],
  methods: {
    getRoastLevel(level) {
      if (!level) {
        return undefined;
      }

      if (level <= 3)
        return  level == 3 ? 'LIGHT/MEDIUM ROAST' : 'LIGHT ROAST';
      else if (level < 6)
        return level == 5 ? 'MEDIUM/DARK ROAST': 'MEDIUM ROAST';
      return 'DARK ROAST';
    },
    getFlavourImageUrl(coffee) {
      if (coffee.flavor_image && coffee.flavor_image.url_medium) {
        return coffee.flavor_image.url_medium;
      }

      return '/default-images/coffee-product.png';
    },
    getBackgroundColor(index, offset = 0) {
      return BG_COLORS[(index + offset) % BG_COLORS.length];
    },
    getFontColor(index, offset = 0) {
      return FONT_COLORS[(index + offset) % BG_COLORS.length];
    },
    humanizeGrind(grind, capitalizeFirstLetter = false) {
      if (!grind)
        return null;

      // Coarse is misspelled in the DB.
      if (grind === 'course') {
        grind = 'coarse';
      }

      grind = this.humanizeString(grind, capitalizeFirstLetter);
      if (grind.toLowerCase() !== 'whole bean'.toLowerCase()) {
        grind += ' grind';
      }

      return grind;
    },
    carouselOptions(forWorkplace = false) {
      const SLIDE_WIDTH = 300;
      // TODO: Handle screen size change
      const MIN_TOUCH_DRAG_WIDTH = 500;

      return {
        centerMode: true,
        touchDrag: true,
        mouseDrag: false,
        navigationEnabled: window.innerWidth > MIN_TOUCH_DRAG_WIDTH,
        navigationClickTargetSize: 2,
        navigationPrevLabel: '&#x25C2',
        navigationNextLabel: '&#x25B8',
        paginationActiveColor: forWorkplace ? '#E15F60' : '#8FA7A3',
        paginationColor: forWorkplace ? '#f4c3c3' : '#C5DEDA',
        perPageCustom: [
          [SLIDE_WIDTH, 1],
          [SLIDE_WIDTH * 2, 1],
          [SLIDE_WIDTH * 3, 2],
          [SLIDE_WIDTH * 4, 3],
          [SLIDE_WIDTH * 5, 4],
          [SLIDE_WIDTH * 6, 5]
        ],
        minSwipeDistance: 5
      };
    },
    // Reorder coffees to avoid to display the same flavours next to each other.
    // Ideally this should be done on backend.
    reorderCoffeesWithSameFlavors(coffees) {
      if (!coffees) {
        return coffees;
      }

      const window = Math.floor(coffees.length / 2);

      for (let i = 0; i < coffees.length - 1; i++) {
        if (this.sameFlavors(coffees[i], coffees[i + 1])) {
          const newPos = (window + i) % coffees.length;
          [coffees[i], coffees[newPos]] = [coffees[newPos], coffees[i]];
        }
      }

      return coffees;
    },
    sameFlavors(coffeeA, coffeeB) {
      if (!coffeeA.flavor_image || !coffeeB.flavor_image) {
        return false;
      }
      return coffeeA.flavor_image.url_medium === coffeeB.flavor_image.url_medium;
    },
    getProductDisplaySize(coffee, size) {
      if (coffee.product_custom_sizes.length > 0)  {
        return size;
      }else {
        if (size === '12oz' && coffee.custom_size_12oz) {
          return coffee.custom_size_12oz;
        } else if (size === '5lb' && coffee.custom_size_5lb) {
          return coffee.custom_size_5lb;
        }
      }   
    },
    calcTaxedPriceCents(priceCents, taxRate) {
      if (!taxRate) {
        return priceCents;
      }

      return priceCents += Math.ceil(priceCents * taxRate);
    }
  }
};